import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tecnodret',
  templateUrl: './tecnodret.component.html',
  styleUrls: ['./tecnodret.component.scss']
})
export class TecnodretComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
